export enum AiMethod {
    Upload = 'Upload',
    EVerify = 'E-Verify',
}
